import {
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const ProductBinAtLocationSchema = z.object({
  productId: productIdFormat.schema,
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  quantity: z.number().int(),
});
export type ProductBinAtLocation = z.infer<typeof ProductBinAtLocationSchema>;

export const listProductBinsAtLocation = {
  name: "listProductBinsAtLocation" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ bins: z.array(ProductBinAtLocationSchema) }),
};
